












import { computed, defineComponent, onMounted, ref, set } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { RecurringBillingSchedule } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import useSystemSettings from "@/hooks/useSystemSettings";
import providers from "@/lib/api";
import PageManageSubscriptionsView from "./components/PageManageRecurringView";

export default defineComponent({
  name: "PageManageRecurring",
  components: { PageManageSubscriptionsView },
  setup() {
    const { authUserStrict } = useAuthUser();
    const { creditCardAllowed } = useSystemSettings();
    const loading = ref(false);
    const canceling = ref(false);
    const creditCardList = ref<CreditCardAssignment[]>([]);

    const creditCard = computed<CreditCardAssignment | null>(() =>
      creditCardList.value.length > 0 ? creditCardList.value[0] : null
    );

    const {
      data: subscriptionsResponse,
      enableScroll,
      items: subscriptionsList,
      getFirstPage: getSubscriptions,
      getNextPage,
    } = usePager(page => {
      return providers.SubscriptionProvider.search(
        {
          data: { consumerIds: [authUserStrict.value.id], sort: "CREATE_TIME,DESC", page },
        },
        [
          "amount",
          "createTime",
          "expirationTime",
          "id",
          "recurringBillingScheduleId",
          { consumer: ["username"] },
          {
            provider: ["id", "username", "screenName", { avatar: ["urlPart"] }],
          },
          {
            recurringBillingSchedule: [
              "id",
              "cancelled",
              "lastBillingTime",
              "cancellationTime",
              { cost: ["cost"] },
              { schedule: ["nextBillingTime"] },
            ],
          },
        ]
      );
    });

    const onCancel = async (rebill: RecurringBillingSchedule, cb: Function) => {
      try {
        if (!subscriptionsResponse.value) return;
        canceling.value = true;
        const response = await providers.RecurringBillingScheduleProvider.cancel({
          data: { id: rebill.id, removeAccess: false },
        });
        set(
          subscriptionsResponse.value,
          "result",
          subscriptionsResponse.value.result.map(i => {
            if (i.recurringBillingScheduleId === rebill.id && i.recurringBillingSchedule) {
              i.recurringBillingSchedule.cancelled = response;
              if (response) {
                i.recurringBillingSchedule.cancellationTime = new Date().toISOString();
              }
            }
            return i;
          })
        );
      } finally {
        cb();
        canceling.value = false;
      }
    };

    const getCreditCards = async () => {
      creditCardList.value = await providers.CreditCardAssignmentsProvider.findAll({ userId: authUserStrict.value.id });
    };

    onMounted(async () => {
      const promises = [getSubscriptions()];
      if (creditCardAllowed.value) {
        promises.push(getCreditCards());
      }
      await Promise.all(promises);
    });

    return {
      loading,
      canceling,
      subscriptionsList,
      enableScroll,
      creditCard,
      getNextPage,
      onCancel,
    };
  },
});
